import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCi, updateCi, deleteCi } from "../services/ciApi";

export function useCreateCi(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCi,
    onSuccess: (data) => {
      console.log(`CI ${data.name} has been created successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateCi(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCi,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`CI ${data.name} has been updated successfully!`);
      queryClient.setQueriesData({ queryKey: [queryData], exact: false }, (old) =>
        old?.map((item) => (item.id === data.id ? data : item))
      );
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteCi(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCi,
    onSuccess: (_, id) => {
      console.log(`CI with ID ${id} has been deleted successfully!`);
      queryClient.setQueryData(queryData, (old) => old?.filter((item) => item.id !== id));
      handleSuccess?.(id);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
